<template>
  <div class="homeheader">
    <div class="header-style">
      <side-menu></side-menu>
      <menu-search></menu-search>
      <user-icon></user-icon>
    </div>
  </div>
</template>
<script>
import SideMenu from "./SideMenu";
import UserIcon from "./UserIcon";
import MenuSearch from "./MenuSearch";
export default {
  name: "Homeheader",
  components: {
    SideMenu,
    UserIcon,
    MenuSearch,
  },
};
</script>

<style lang="less" scoped>
.homeheader {
  .header-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin: 0 16px;
    padding: 0 16px;
    background-color: #fff;
    box-shadow: 0 0px 10px rgba(0, 0, 0, 0.15);
    position: relative;
    z-index: 100;
    height: 60px;
  }
}
</style>
